import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAiLogoSimpleinline = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 132 132",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M57.421 5.913c3.002-7.884 14.156-7.884 17.158 0l8.345 21.915a36.72 36.72 0 0 0 21.248 21.249l21.915 8.344c7.884 3.002 7.884 14.156 0 17.158l-21.915 8.345a36.72 36.72 0 0 0-21.248 21.248l-8.345 21.915c-3.002 7.884-14.156 7.884-17.158 0l-8.344-21.915a36.72 36.72 0 0 0-21.249-21.248L5.913 74.578c-7.884-3.002-7.884-14.156 0-17.158l21.915-8.344a36.72 36.72 0 0 0 21.249-21.249z"
	})
});
export default SvgAiLogoSimpleinline;
